export default __webpack_public_path__ + "static/media/metabase.0c88b686.svg";